/* eslint-disable complexity */
/* eslint-disable max-statements */
import { validators } from '../../utils/validators';

const { REQUIRED, URL } = validators;

const isValidKeyMode = keyMode => {
    if (keyMode && Array.isArray(keyMode)) {
        return keyMode.includes('live') || keyMode.includes('test');
    }
    return (keyMode && keyMode.test) || (keyMode && keyMode.live);
};

const isTestKeyEnabled = keyMode => {
    if (keyMode && Array.isArray(keyMode)) {
        return keyMode.includes('test');
    }
    return keyMode && keyMode.test;
};

const isLiveKeyEnabled = keyMode => {
    if (keyMode && Array.isArray(keyMode)) {
        return keyMode.includes('live');
    }
    return keyMode && keyMode.live;
};

const validate = values => {
    console.log("validate values",values,"------>>>");
    const errors = { encryptionData: {} };

    let perTransactionLimit = values.perTransactionLimit;
    let dailyTransactionLimit = values.dailyTransactionLimit;
    let monthlyTransactionLimit = values.monthlyTransactionLimit;

    if (Math.ceil(perTransactionLimit) != perTransactionLimit) {
        errors.perTransactionLimit = 'Only integer values are allowed';
    }
    if (Math.ceil(dailyTransactionLimit) != dailyTransactionLimit) {
        errors.dailyTransactionLimit = 'Only integer values are allowed';
    }
    if (Math.ceil(monthlyTransactionLimit) != monthlyTransactionLimit) {
        errors.monthlyTransactionLimit = 'Only integer values are allowed';
    }

    if (!isValidKeyMode(values.keyMode)) {
        errors.keyMode = 'Please select Mode';
    }
    if (!values.modeOfIntegration) {
        errors.modeOfIntegration = 'Please select Mode Of Integration';
    }
    if (values.modeOfIntegration && values.modeOfIntegration.length <= 0) {
        errors.modeOfIntegration = 'Please select Mode Of Integration';
    }
    if (
        values.modeOfIntegration &&
        Array.isArray(values.modeOfIntegration) &&
        values.modeOfIntegration.length === 1
    ) {
        if (
            !Array.isArray(values.modeOfIntegration[0]) &&
            typeof values.modeOfIntegration[0] !== 'string'
        ) {
            errors.modeOfIntegration = 'Please select Mode Of Integration';
        }
    }
    if (!values.security) {
        errors.security = 'Please select Security';
    }
    if (values.allowRetry && !values.retryCount) {
        errors.retryCount = 'Please select retry count';
    }
    if (!values.platform) {
        errors.platform = 'Please select Platform';
    }
    if (values.platform && values.platform.length <= 0) {
        errors.platform = 'Please select Platform';
    }
    if (values.isMerchantTatEnabled && !values.merchantTxnTat) {
        errors.merchantTxnTat = 'Please Enter Merchant Transaction TAT';
    }
    if (!values.refundQueueTat || values.refundQueueTat == 0) {
        errors.refundQueueTat = 'Please Enter Refund Queue TAT';
    }else if (values.refundQueueTat < 0) {
        errors.refundQueueTat = 'Please Enter valid Refund Queue TAT';
    }

    if (
        values.platform &&
        Array.isArray(values.platform) &&
        values.platform.length === 1
    ) {
        if (
            !Array.isArray(values.platform[0]) &&
            typeof values.platform[0] !== 'string'
        ) {
            errors.platform = 'Please select Platform';
        }
    }

    if (values.isEncryptionEnabled) {
        if (
            isValidKeyMode(values.keyMode) &&
            isTestKeyEnabled(values.keyMode) &&
            (!values.encryptionData || !values.encryptionData?.encTestKey)
        ) {
            errors.encryptionData.encTestKey =
                'Please provide encryption test key';
        }

        if (
            isValidKeyMode(values.keyMode) &&
            isLiveKeyEnabled(values.keyMode) &&
            (!values.encryptionData || !values.encryptionData?.encLiveKey)
        ) {
            errors.encryptionData.encLiveKey =
                'Please provide encryption live key';
        }
    }

    const whiteListedDomainsError = [{}];
    const whitelistedDomains = values.whitelistedDomains; 
    if (values.isDomainWhitelisted) {
        whitelistedDomains.map((field,index)=>{
            if (!field.domain) {
                whiteListedDomainsError[index] ={domain:'Please enter URL'};
            }
            else if(URL(field.domain)){
                whiteListedDomainsError[index] ={domain:'Must be a valid URL'};
            }
        })
    }
    errors.whitelistedDomains=whiteListedDomainsError;

    if (values.isMerTxnLimitEnabled) {
        perTransactionLimit = perTransactionLimit
            ? parseInt(perTransactionLimit, 10)
            : null;
        dailyTransactionLimit = dailyTransactionLimit
            ? parseInt(dailyTransactionLimit, 10)
            : null;
        monthlyTransactionLimit = monthlyTransactionLimit
            ? parseInt(monthlyTransactionLimit, 10)
            : null;

        if (perTransactionLimit <= 0) {
            errors.perTransactionLimit =
                'Per transaction limit cant be less than 1';
        }
        if (dailyTransactionLimit <= 0) {
            errors.dailyTransactionLimit =
                'Daily transaction limit cant be less than 1';
        }
        if (monthlyTransactionLimit <= 0) {
            errors.monthlyTransactionLimit =
                'Monthly transaction limit cant be less than 1';
        }

        if (perTransactionLimit === null || perTransactionLimit === undefined) {
            errors.perTransactionLimit = 'Please provide per transaction limit';
        }
        if (
            dailyTransactionLimit === null ||
            dailyTransactionLimit === undefined
        ) {
            errors.dailyTransactionLimit =
                'Please provide daily transaction limit';
        }
        if (
            monthlyTransactionLimit === null ||
            monthlyTransactionLimit === undefined
        ) {
            errors.monthlyTransactionLimit =
                'Please provide monthly transaction limit';
        }

        if (
            dailyTransactionLimit &&
            perTransactionLimit &&
            dailyTransactionLimit < perTransactionLimit
        ) {
            errors.dailyTransactionLimit =
                'Daily transaction limit should be greater than per transaction limit';
            errors.perTransactionLimit =
                'Per transaction limit should be less than daily transaction limit';
        }
        if (
            dailyTransactionLimit &&
            monthlyTransactionLimit &&
            monthlyTransactionLimit < dailyTransactionLimit
        ) {
            errors.monthlyTransactionLimit =
                'Monthly transaction limit should be greater than daily transaction limit';
            errors.dailyTransactionLimit =
                'Daily transaction limit should be less than monthly transaction limit';
        }
        if (
            perTransactionLimit &&
            dailyTransactionLimit &&
            monthlyTransactionLimit &&
            monthlyTransactionLimit < perTransactionLimit &&
            dailyTransactionLimit < perTransactionLimit
        ) {
            errors.perTransactionLimit =
                'Per transaction limit should be less than monthly and daily transaction limit';
        } else if (
            monthlyTransactionLimit &&
            perTransactionLimit &&
            monthlyTransactionLimit < perTransactionLimit
        ) {
            errors.perTransactionLimit =
                'Per transaction limit should be less than monthly transaction limit';
        } else if (
            dailyTransactionLimit &&
            perTransactionLimit &&
            dailyTransactionLimit < perTransactionLimit
        ) {
            errors.perTransactionLimit =
                'Per transaction limit should be less than daily transaction limit';
        }
    }

    if (values.isMandateRegTatEnabled) {
        if (REQUIRED(values.mandateRegApprovalTat)) {
            errors.mandateRegApprovalTat = 'Please Mandate Registration TAT';
        } else if (
            parseInt(values.mandateRegApprovalTat, 10) <= 0 ||
            parseInt(values.mandateRegApprovalTat, 10) > 999
        ) {
            errors.mandateRegApprovalTat =
                'Mandate Registration TAT should be min 1 and max 999';
        }

        if (
            values.mandateRegFirstExeTat !== undefined &&
            values.mandateRegFirstExeTat !== null &&
            (parseInt(values.mandateRegFirstExeTat, 10) <= 0 ||
                parseInt(values.mandateRegFirstExeTat, 10) > 999)
        ) {
            errors.mandateRegFirstExeTat =
                'First Mandate Registration Execution TAT should be min 1 and max 999';
        }
    }

    return errors;
};

export default validate;
